import { useEffect, useState } from 'react';

import {
  EIP6963AnnounceProviderEvent,
  EIP6963ProviderDetail,
} from 'lib/ethereum/walletDiscovery/types';
import {
  listenForEip6963Web3Wallets,
  stopListeningForEip6963Web3Wallets,
} from 'lib/ethereum/walletDiscovery/walletDiscovery';

export type ProvidersMap = {
  // Note that uuid changes in TokenPocket
  [rdns: string]: EIP6963ProviderDetail;
};

export const useDiscoverEip6963Wallets = ({
  waitMs,
}: {
  waitMs: number;
}): ProvidersMap | undefined => {
  const [timeoutPass, setTimeoutPass] = useState(false);
  const [providers, setProviders] = useState<ProvidersMap>({});

  useEffect(() => {
    const onFound = (event: EIP6963AnnounceProviderEvent) => {
      console.log(`[walletDiscovery] Found "${event.detail.info.rdns}"`);
      setProviders(state => ({
        ...state,
        [event.detail.info.rdns]: event.detail,
      }));
    };
    listenForEip6963Web3Wallets(onFound);
    return () => stopListeningForEip6963Web3Wallets(onFound);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setTimeoutPass(true);
    }, waitMs);
    return () => clearTimeout(timeout);
  }, [waitMs]);

  return timeoutPass ? providers : undefined;
};
